import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import Translations from './models/Translations';

const element: HTMLElement = document.getElementById('searchResults') as HTMLElement;
if (element != null) {
  const language = element.getAttribute("data-language") as string;
  const persona = element.getAttribute("data-persona") as string;
  const itemsPerPage = parseInt(element.getAttribute("data-items-per-page") as string);
  const keywords = element.getAttribute("data-keywords") as string;
  const pageTitle = element.getAttribute("data-page-title") as string;
  const summaryLength : number = parseInt( element.getAttribute("data-summaryLength") as string);

  const translations = new Translations({
    searchButtonText: element.getAttribute("data-search-button-text") as string,
    searchPlaceholder: element.getAttribute("data-search-placeholder") as string,
    result: {
      noResultsSentence: element.getAttribute("data-no-results-sentence") as string,
      singleResultSentence: element.getAttribute("data-single-result-sentence") as string,
      multipleResultsSentence: element.getAttribute("data-multiple-results-sentence") as string,
      singleResultText: element.getAttribute("data-single-result-text") as string,
      multipleResultsText: element.getAttribute("data-multiple-results-text") as string,
    },
    page: {
      of: element.getAttribute("data-paging-of") as string,
      previous: element.getAttribute("data-paging-previous") as string,
      next: element.getAttribute("data-paging-next") as string
    }
  });

  ReactDOM.render(
    <React.StrictMode>
      <App pageTitle={pageTitle} keywords={keywords} itemsPerPage={itemsPerPage} translations={translations} language={language} persona={persona} summaryLength={summaryLength} />
    </React.StrictMode>,
    element
  );
}